export default "__VITE_ASSET__d0L7N3NG__"